import * as z from "zod/v4";

export const ShopperAgentReplyConfigSchema = z.object({
  enabled: z.boolean().optional(),
});

export type ShopperAgentReplyConfig = z.infer<
  typeof ShopperAgentReplyConfigSchema
>;
